<template>
  <sweet-modal ref="modal" overlay-theme="dark">
    <div class="text-center">
      <loader/>
      {{ $t('message.hero.logging_in') }}
    </div>
  </sweet-modal>
</template>

<script>
  import { SweetModal } from 'sweet-modal-vue'
  import Loader from './Loader'

  export default {
    components: {
      Loader,
      SweetModal
    },
    methods: {
      openModal () {
        this.$refs.modal.open()
      },
      closeModal () {
        this.$refs.modal.close()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/loader/LoaderModal.vue